import { t } from '@gem/modules/i18n';

import { pluralize } from './pluralize';

export const getParticipantsCountStr = (count: number): string => {
  return `${count} ${pluralize(count, {
    one: t('common_participants_one'),
    few: t('common_participants_few'),
    many: t('common_participants_many'),
    zero: t('common_participants_many'),
    two: t('common_participants_few'),
    other: t('common_participants_many'),
  })}`;
};
